import { useIntl } from 'react-intl';
import { SpecialStatus } from '@Page/SalaryTaxCard/component/SalaryTaxCardMainTable/StatusColomnComponent/StatusColumnComponent';
import { TaxcardStatusCodes } from '@Page/SalaryTaxCard/reducers/altinnHandling';
import { TaxcardDTO } from '@Page/SalaryTaxCard/SalaryTaxCard.types';
import { Status, StatusVariant, Tooltip, TooltipContent, TooltipTrigger } from '@tlx/atlas';
import { capitalizeFirstLetter } from '@Util/stringUtils';
import { InlineMarkdown } from '@tlx/astro-shared';

export function TaxcardStatus({ taxcard }: { taxcard: TaxcardDTO }) {
    const intl = useIntl();
    const statusObj = mapToStatus(
        taxcard.status,
        intl.formatMessage({ id: 'text_fetched' }),
        intl.formatMessage({ id: 'text_not_fetched' }),
        intl.formatMessage({ id: 'text_unknown' }),
    );

    const statusDescription = statusObj.text ?? capitalizeFirstLetter(taxcard.statusDescription ?? '');
    return (
        <Tooltip>
            <TooltipTrigger>
                <div title="">
                    <Status variant={statusObj.variant}>
                        <span>{statusDescription}</span>
                    </Status>
                </div>
            </TooltipTrigger>
            <TooltipContent>
                <InlineMarkdown>{`${statusDescription}\n\n${intl.formatMessage({
                    id: 'text_altinn_errors_altinnkode',
                })}: ${taxcard.status}`}</InlineMarkdown>
            </TooltipContent>
        </Tooltip>
    );
}

type StatusObj = {
    variant: StatusVariant;
    text?: string;
};
function mapToStatus(
    code: string | undefined,
    fetchedText: string,
    notFetchedText: string,
    unknownText: string,
): StatusObj {
    switch (code) {
        case TaxcardStatusCodes.OK:
            return {
                variant: 'success',
                text: fetchedText,
            };
        case TaxcardStatusCodes.NO_DEDUCTION:
        case TaxcardStatusCodes.NO_TAXCARD:
            return {
                variant: 'neutral',
            };
        case TaxcardStatusCodes.INVALID_ORGNO:
        case TaxcardStatusCodes.INVALID_PERS_D_NUM:
            return {
                variant: 'error',
            };

        case TaxcardStatusCodes.WORK_PERMIT_UNCLEAR:
        case TaxcardStatusCodes.D_NUM_EXPIRED_PERS_NUM_OK:
        case TaxcardStatusCodes.STATUS_MANUAL:
            return {
                variant: 'warning',
            };

        case SpecialStatus.NOT_FETCHED:
            return {
                variant: 'warning',
                text: notFetchedText,
            };
        default:
            return {
                variant: 'warning',
                text: unknownText,
            };
    }
}
